import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomvalidationService } from '../../customvalidation.service';

@Component({
  selector: 'lib-business-contact-info',
  templateUrl: './business-contact-info.component.html',
  styleUrls: ['./business-contact-info.component.css']
})
export class BusinessContactInfoComponent implements OnInit {
  @Input() busContactForm: any;
  @Input() busAddrObj = {
    buscon_last_name : "",
    buscon_first_name : "",
    buscon_title : "",
    buscon_phAreaCd : "",
    buscon_phExchNbr : "",
    buscon_phTrnkNbr : "",
    buscon_phExtNbr : "",
    buscon_email_addr : "" ,
    buscon_web_address : ""
  } ;
	errorMessages = {
    invalidAtDot: "Email address seems incorrect (check @ and .'s)",
    invalidEmailChar: "The username in the e-mail address contains invalid characters.",
    invalidEmailDomain: "The domain name in the e-mail address contains invalid characters.",
    invalidEmailUserName: "The username in the e-mail address doesn't seem to be valid.",
    invalidEmailIp: "Destination IP address in the e-mail address is invalid!",
    invalidDomainName: "The domain name in the e-mail address does not seem to be valid.",
    invalidDomainOrCountry: "The e-mail address must end in a well-known domain or two letter " + "country.",
    missingEmailHost: "This email address is missing a hostname!"
  }
  
  constructor(private fb: FormBuilder, private customValidator: CustomvalidationService) { }

  ngOnInit(): void {
    this.busContactForm.addControl("buscon_last_name", this.fb.control(this.busAddrObj.buscon_last_name))
    this.busContactForm.addControl("buscon_first_name", this.fb.control(this.busAddrObj.buscon_first_name))
    this.busContactForm.addControl("buscon_title", this.fb.control(this.busAddrObj.buscon_title))
    this.busContactForm.addControl("buscon_phAreaCd", this.fb.control(this.busAddrObj.buscon_phAreaCd, Validators.pattern('[0-9]{3}')))
    this.busContactForm.addControl("buscon_phExchNbr", this.fb.control(this.busAddrObj.buscon_phExchNbr, Validators.pattern('[0-9]{3}')))
    this.busContactForm.addControl("buscon_phTrnkNbr", this.fb.control(this.busAddrObj.buscon_phTrnkNbr, Validators.pattern('[0-9]{4}')))
    this.busContactForm.addControl("buscon_phExtNbr", this.fb.control(this.busAddrObj.buscon_phExtNbr))
    this.busContactForm.addControl("buscon_email_addr", this.fb.control(this.busAddrObj.buscon_email_addr, this.customValidator.emailValidator()))
    this.busContactForm.addControl("buscon_web_address", this.fb.control(this.busAddrObj.buscon_web_address))
  }

  get buscon_last_name() {
    return this.busContactForm.get("buscon_last_name");
  }
  get buscon_first_name() {
    return this.busContactForm.get("buscon_first_name");
  }
  get title() {
    return this.busContactForm.get("title");
  }
  get buscon_title() {
    return this.busContactForm.get("buscon_title");
  }
  get buscon_phAreaCd() {
    return this.busContactForm.get("buscon_phAreaCd");
  }
  get buscon_phExchNbr() {
    return this.busContactForm.get("buscon_phExchNbr");
  }
  get buscon_phTrnkNbr() {
    return this.busContactForm.get("buscon_phTrnkNbr");
  }
  get buscon_phExtNbr() {
    return this.busContactForm.get("buscon_phExtNbr");
  }

  get buscon_email_addr() {
    return this.busContactForm.get("buscon_email_addr");
  }
  get buscon_web_address() {
    return this.busContactForm.get("buscon_web_address");
  }

  onInputEntry(event, nextInput) {
    if ((this.busContactForm.get("buscon_phAreaCd").value.length === 0 && this.busContactForm.get("buscon_phExchNbr").value.length === 0 && this.busContactForm.get("buscon_phTrnkNbr").value.length === 0) || ((this.busContactForm.get("buscon_phAreaCd").value.length === 3 && this.busContactForm.get("buscon_phExchNbr").value.length === 3 && this.busContactForm.get("buscon_phTrnkNbr").value.length === 4))) {
      this.busContactForm.get("buscon_phAreaCd")?.setErrors(null)
    } else if ((this.busContactForm.get("buscon_phAreaCd").value.length === 3 || this.busContactForm.get("buscon_phExchNbr").value.length === 3 || this.busContactForm.get("buscon_phTrnkNbr").value.length === 4) && ((!this.busContactForm.get("buscon_phAreaCd")?.errors?.pattern && !this.busContactForm.get("buscon_phExchNbr").errors && !this.busContactForm.get("buscon_phTrnkNbr").errors))) {

      this.busContactForm.get("buscon_phAreaCd")?.setErrors({ phnErr: true })
    }
    else {
      if (this.busContactForm.get("buscon_phAreaCd").value.length === 3) {
        this.busContactForm.get("buscon_phAreaCd")?.setErrors(null)
      }
    }
    let input = event.target;
    let length = input.value.length;
    let maxLength = input.attributes.maxlength.value;

    if (length >= maxLength) {
      nextInput.focus();
    }
  }
}
